<script setup lang="ts">
import { getCurrentInstance } from 'vue'

interface Props {
  colorFrom?: string
  colorTo?: string
}

withDefaults(defineProps<Props>(), {
  colorFrom: '#88B9EB',
  colorTo: '#0A368A',
})

defineOptions({ inheritAttrs: false })

// Base-36 (0-9 + a-z) keeps the fallback id short and URL-safe.
const BASE_36 = 36
const uid = getCurrentInstance()?.uid ?? Math.random().toString(BASE_36).slice(2)
const maskId = `ic-poker-chip-mask-${uid}`
const gradientId = `ic-poker-chip-gradient-${uid}`
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <mask
      :id="maskId"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g :mask="`url(#${maskId})`">
      <path
        d="M11.9998 22C10.6165 22 9.31647 21.7375 8.09981 21.2125C6.88314 20.6875 5.82481 19.975 4.92481 19.075C4.02481 18.175 3.31231 17.1167 2.78731 15.9C2.26231 14.6833 1.99981 13.3833 1.99981 12C1.99981 10.6167 2.26231 9.31667 2.78731 8.1C3.31231 6.88333 4.02481 5.825 4.92481 4.925C5.82481 4.025 6.88314 3.3125 8.09981 2.7875C9.31647 2.2625 10.6165 2 11.9998 2C13.3831 2 14.6831 2.2625 15.8998 2.7875C17.1165 3.3125 18.1748 4.025 19.0748 4.925C19.9748 5.825 20.6873 6.88333 21.2123 8.1C21.7373 9.31667 21.9998 10.6167 21.9998 12C21.9998 13.3833 21.7373 14.6833 21.2123 15.9C20.6873 17.1167 19.9748 18.175 19.0748 19.075C18.1748 19.975 17.1165 20.6875 15.8998 21.2125C14.6831 21.7375 13.3831 22 11.9998 22ZM10.9998 19.925V18.925C10.4165 18.8417 9.85397 18.6833 9.31231 18.45C8.77064 18.2167 8.26647 17.9333 7.79981 17.6L7.09981 18.325C7.64981 18.7583 8.25397 19.1125 8.91231 19.3875C9.57064 19.6625 10.2665 19.8417 10.9998 19.925ZM12.9998 19.925C13.7331 19.8417 14.429 19.6625 15.0873 19.3875C15.7456 19.1125 16.3498 18.7583 16.8998 18.325L16.1998 17.6C15.7331 17.9333 15.229 18.2167 14.6873 18.45C14.1456 18.6833 13.5831 18.8417 12.9998 18.925V19.925ZM11.9998 17C13.3831 17 14.5623 16.5125 15.5373 15.5375C16.5123 14.5625 16.9998 13.3833 16.9998 12C16.9998 10.6167 16.5123 9.4375 15.5373 8.4625C14.5623 7.4875 13.3831 7 11.9998 7C10.6165 7 9.43731 7.4875 8.46231 8.4625C7.48731 9.4375 6.99981 10.6167 6.99981 12C6.99981 13.3833 7.48731 14.5625 8.46231 15.5375C9.43731 16.5125 10.6165 17 11.9998 17ZM18.3248 16.9C18.7581 16.35 19.1123 15.7458 19.3873 15.0875C19.6623 14.4292 19.8415 13.7333 19.9248 13H18.9248C18.8415 13.5833 18.6831 14.1458 18.4498 14.6875C18.2165 15.2292 17.9331 15.7333 17.5998 16.2L18.3248 16.9ZM5.67481 16.9L6.39981 16.175C6.06647 15.7083 5.78314 15.2083 5.54981 14.675C5.31647 14.1417 5.15814 13.5833 5.07481 13H4.07481C4.15814 13.7333 4.33731 14.4292 4.61231 15.0875C4.88731 15.7458 5.24147 16.35 5.67481 16.9ZM11.9998 16L8.99981 12L11.9998 8L14.9998 12L11.9998 16ZM4.07481 11H5.07481C5.15814 10.4167 5.31647 9.85833 5.54981 9.325C5.78314 8.79167 6.06647 8.29167 6.39981 7.825L5.67481 7.1C5.24147 7.65 4.88731 8.25417 4.61231 8.9125C4.33731 9.57083 4.15814 10.2667 4.07481 11ZM18.9248 11H19.9248C19.8415 10.2667 19.6581 9.57083 19.3748 8.9125C19.0915 8.25417 18.7331 7.65 18.2998 7.1L17.5998 7.8C17.9331 8.26667 18.2165 8.77083 18.4498 9.3125C18.6831 9.85417 18.8415 10.4167 18.9248 11ZM7.82481 6.4C8.29147 6.06667 8.79147 5.78333 9.32481 5.55C9.85814 5.31667 10.4165 5.15833 10.9998 5.075V4.075C10.2665 4.15833 9.57064 4.3375 8.91231 4.6125C8.25397 4.8875 7.64981 5.24167 7.09981 5.675L7.82481 6.4ZM16.1998 6.4L16.8998 5.7C16.3498 5.26667 15.7456 4.90833 15.0873 4.625C14.429 4.34167 13.7331 4.15833 12.9998 4.075V5.075C13.5831 5.15833 14.1456 5.31667 14.6873 5.55C15.229 5.78333 15.7331 6.06667 16.1998 6.4Z"
        :fill="`url(#${gradientId})`"
      />
    </g>
    <defs>
      <linearGradient
        :id="gradientId"
        x1="11.9998"
        y1="2"
        x2="11.9998"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop :stop-color="colorFrom" />
        <stop offset="1" :stop-color="colorTo" />
      </linearGradient>
    </defs>
  </svg>
</template>
